export const parseCouponEndTime = (time?: string | null) => {
  if (time === undefined) return 0
  if (time === null) return Number.MAX_SAFE_INTEGER
  return new Date(time).getTime()
}
